<button type="button" class="app-button" [ngClass]="loading ? 'loading' : ''"
    [disabled]="disabled" [class.full]="full" [class.inverted]="inverted"
    (click)="click($event)" [class.outline]="outline" [class.next]="next"
    [class.bordless]="bordless" [class.danger]="danger"
    [class.phantom]="phantom" [class.reverse]="reverse">
    <div class="app-button-label" [class.center]="center" *ngIf="showContent"
        #content>
        <svg-icon src="assets/images/icon-times.svg" class="reject"
            [class.d-none]="!reject"></svg-icon>
        <ng-content></ng-content>
    </div>
    <span class="app-button-label" *ngIf="!showContent">{{label}}</span>
    <div *ngIf="loading" class="app-button-loading">
        <svg-icon src="assets/images/icon-loading.svg"
            class="app-button-icon"></svg-icon>
    </div>
</button>